import { Utils } from "../../../helper/General/Utils";
export const promiseSnakeToCamelCaseObject = promise => promise.then(Utils.snakeToCamelCaseObject);
